import React from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  TableContainer,
  Box
} from '@mui/material';

import { IconButton } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";


export interface ContatoTableProps<T> {
  data: T[];
  notPaginated?: boolean;
  page?: number;
  perPage?: number;
  totalItems: number;
  rowsPerPageOptions?: number[];
  onPageChange?: (newPage: number) => void;
  onPerPageChange?: (newPerPage: number) => void;
  renderColunas: (contato: T) => React.ReactNode;
  renderCabecalho: () => React.ReactNode;
  onEdit?: (contato: T) => void;
  onDelete?: (contato: T) => void;
  onSelect?: (contato: T) => void;
  showAcoes?: boolean;
  isExterno?: boolean;
}

export function ContatoTable<T>({
  data,
  notPaginated,
  page,
  perPage,
  totalItems,
  rowsPerPageOptions,
  onPageChange,
  onPerPageChange,
  renderCabecalho,
  renderColunas,
  onEdit,
  onDelete,
  onSelect,
  showAcoes = false,
  isExterno,
}: ContatoTableProps<T>) {
  return (
    <Box sx={{ flex: 1, width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      <TableContainer sx={{ flex: 1 }}>
        <Table stickyHeader size='small' sx={{ overflow: "auto" }}>
          <TableHead>
            <TableRow>
              {renderCabecalho()}
              {showAcoes && <TableCell>Ações</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((contato, idx) => (
              <TableRow
                key={idx}
                hover
                onClick={() => onSelect?.(contato)}
              >
                {renderColunas(contato)}
                {showAcoes && (
                  <TableCell>
                    {onEdit && (
                      <IconButton onClick={() => onEdit(contato)}>
                        <Edit />
                      </IconButton>
                    )}
                    {isExterno && onDelete && (
                      <IconButton onClick={() => onDelete(contato)}>
                        <Delete />
                      </IconButton>
                    )}
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {!notPaginated && <TablePagination
        component="div"
        count={totalItems}
        page={page ?? 1}
        onPageChange={(_, newPage) => onPageChange?.(newPage)}
        rowsPerPage={perPage ?? 10}
        onRowsPerPageChange={(e) => onPerPageChange?.(parseInt(e.target.value, 10))}
        rowsPerPageOptions={rowsPerPageOptions ?? [5, 10, 25, 50]}
      />}
    </Box>
  );
}